import { styled } from "../../../../styles";

/**
 * A feature switch with its info tooltip. The tooltip trigger sits OUTSIDE the
 * checkbox's <label> on purpose: inside it, the tooltip copy would pollute the
 * flag's accessible name, and clicking the icon would toggle the flag.
 */
export const FlagRow = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "4px",
});
